import { Component, OnDestroy, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserAccountService } from '../../../common/service/user-account.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { LocalDate } from '../../../core/model/local-date';
import { CompanyService } from '../../service/data/company.service';
import { Company } from '../../model/company';
import { LanguageService } from '../../../core/service/language.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationService } from '../../../core/service/navigation.service';

@Component({
    selector: 'app-company-fortnox-config',
    templateUrl: './company-fortnox-config.component.html',
    styleUrls: ['./company-fortnox-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyFortnoxConfigComponent implements OnDestroy, OnInit {
  constructor(
    private _companyService: CompanyService,
    private _modalService: ActionWindowService,
    private _domSanitizer: DomSanitizer
  ) {}

  fortnoxUrl: string;

  public errorMessage: string;

  private _subscription: Subscription = new Subscription();

  dataContext: Company;
  readonly form: FormGroup;

  firstAccDate: LocalDate;

  close() {
    this._modalService.close();
  }

  ngOnInit(): void {
    this._subscription.add(
      this._companyService.getFortnoxRegisterUrl(this.dataContext.id).subscribe(res => {
        this.fortnoxUrl = res;
      })
    );
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }
}
